import { render, staticRenderFns } from "./ZddCertificateRecordItem.vue?vue&type=template&id=3e77a630&scoped=true"
import script from "./ZddCertificateRecordItem.vue?vue&type=script&lang=js"
export * from "./ZddCertificateRecordItem.vue?vue&type=script&lang=js"
import style0 from "./ZddCertificateRecordItem.vue?vue&type=style&index=0&id=3e77a630&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e77a630",
  null
  
)

export default component.exports